export default __webpack_public_path__ + "static/media/barcode.7325e21a.svg";